import type { CheckoutSession } from '../types/checkout';

// Display-only: read the same immutable intent used by all four app links.
// Never replace order_amount or infer a confirmed debit from this launch data.
export function aipayPaymentAmount(session: CheckoutSession, intent: string): string | undefined {
  if (session.channel_code !== 'AIPAY' || session.payment_method_code !== 'UPI' || session.pricing_currency !== 'INR') {
    return undefined;
  }
  try {
    const uri = new URL(intent);
    const values = uri.searchParams;
    if (uri.protocol !== 'upi:' || uri.hostname.toLowerCase() !== 'pay' || uri.pathname !== '' ||
        values.getAll('pa').length !== 1 || !values.get('pa')?.trim() ||
        values.getAll('am').length !== 1 || values.getAll('cu').length > 1 ||
        (values.get('cu') && values.get('cu')?.toUpperCase() !== 'INR')) {
      return undefined;
    }
    const amount = (values.get('am') ?? '').trim();
    if (!/^[0-9]+(?:\.[0-9]{1,2}0*)?$/.test(amount)) return undefined;
    if (!/[1-9]/.test(amount)) return undefined;
    // Decimal text only: Number/toFixed can lose paisa on large valid amounts.
    const [integer, fraction = ''] = amount.split('.');
    const whole = integer.replace(/^0+(?=[0-9])/, '');
    const paisa = fraction.padEnd(2, '0').slice(0, 2);
    return paisa === '00' ? whole : `${whole}.${paisa}`;
  } catch {
    return undefined;
  }
}
